import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import useAppState from "../../context/AppContext";
import { IInfoStep } from "../../context/model";
import { isDisabledStep } from "../../utils/dataUtils";
import MgpTooltip from "../../elements/MgpTooltip/MgpTooltip";
import { handleKeyDown } from "../../utils/utils";

interface MgpProgressbarWithStepsProps {

}

export default function MgpProgressbarWithSteps({ ...props}: MgpProgressbarWithStepsProps) {
  const {
    state: {infoSteps, proposition},
  } = useAppState();
  const currentLocation = useLocation();
  const navigate = useNavigate();

  const isActiveStep = (step: IInfoStep) => {
    const currentIndex = infoSteps.findIndex(s => s.path === currentLocation.pathname);
    const index = infoSteps.findIndex(s => s.path === step.path);
   
    if (index === currentIndex) {
      return 'active';
    } else if (index > currentIndex) {
      return "incomplete";
    } else {
      return "completed";
    }
  }

  const getStateCategory = (category: 'PERSONAL' | 'SIGNATURE' | 'BENEFICIARY' | 'GUARANTY') => {
    const firstStep = infoSteps.filter(step => step.category === category)[0];
    return isActiveStep(firstStep) === 'incomplete' ? 'incomplete' : 'completed';
  }

  const handleChangeStep = (step: IInfoStep) => {
    if (!isDisabledStep(proposition!,step)) {
      navigate({
        pathname: step.path,
        search: createSearchParams({
            id: proposition!.propositionId
        }).toString(),
      });
    }
  }

  const isLastStep = (step: IInfoStep) => {
    const steps = infoSteps.filter(el => el.category === "SIGNATURE" && !el.menuHide);
    const index = steps.findIndex(el => el.path === step.path);
    if (step.category === "SIGNATURE") {
      if (index === steps.length - 1) {
        return true;
      }
    }
    return false;
  }

    return (
      <div className="stepper-wrapper">
        <div className={`stepper-item ${getStateCategory("PERSONAL")} mt-xs`}>
          <div className="step-counter">{getStateCategory("PERSONAL") === "completed" ? <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_affilie_R.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_affilie_R" /> : <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_affilie_B.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_affilie_B"/>}</div>
          <div className="step-name fz-sm"> Je&nbsp;m'affilie </div>
        </div>

        {
          infoSteps.filter(s => s.category === "PERSONAL").map(subStep => <div key={subStep.code} className={`stepper-item ${isActiveStep(subStep)}`}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        }

        
        {proposition?.configuration?.canBeAddedBeneficiaries &&
          <div className={`stepper-item ${getStateCategory("BENEFICIARY")} mt-xs`}>
            <div className="step-counter">{getStateCategory("BENEFICIARY") === "completed" ? <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_proches_R.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_proches_R" /> : <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_proches_B.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_proches_B"/>}</div>
            <div className="step-name fz-sm">Je couvre mes&nbsp;proches</div>
          </div>
        }

        {
          proposition?.configuration?.canBeAddedBeneficiaries && infoSteps.filter(s => s.category === "BENEFICIARY").map(subStep => <div key={subStep.code} className={`stepper-item ${isActiveStep(subStep)}`}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        }
        
        {proposition?.configuration?.hasOfferStep &&
          <div className={`stepper-item ${getStateCategory("GUARANTY")} mt-xs`}>
            <div className="step-counter">{getStateCategory("GUARANTY") === "completed" ? <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_couverture_R.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_couverture_R"/> : <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_couverture_B.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_couverture_B"/>}</div>
            <div className="step-name fz-sm">Je renforce ma&nbsp;couverture</div>
          </div>
        }
        {
          proposition?.configuration?.hasOfferStep && infoSteps.filter(s => s.category === "GUARANTY").map(subStep =>  <div key={subStep.code} className={`stepper-item ${isActiveStep(subStep)}`}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        }
        
        <div className={`stepper-item ${getStateCategory("SIGNATURE")} mt-xs`}>
          <div className="step-counter">{getStateCategory("SIGNATURE") === "completed" ? <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_finalise_R.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_finalise_R"/> : <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_finalise_B.svg"} width="50" height="50" style={{boxShadow: "none"}} alt="Picto_finalise_B"/>}</div>
          <div className="step-name fz-sm">Je&nbsp;finalise</div>
        </div>

        {
          infoSteps.filter(s => s.category === "SIGNATURE").map(subStep => <div key={subStep.code} className={`${isLastStep(subStep) ? `last-step-item` : 'stepper-item'} ${isActiveStep(subStep)}`} style={subStep.menuHide ? {display: "none"}: {}}><MgpTooltip text={subStep.label} children={<div className={`sub-step ${isActiveStep(subStep)} ${isDisabledStep(proposition!,subStep) ? '' : 'clickable'}`} onClick={() => handleChangeStep(subStep)} role="button" tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}></div>} position='bottom' backgroundColor="#fff" textColor="#144196" zIndex={5}/></div>)
        }
        
      </div>
    );
 
} 